<header class="header">
  <div
    class="header__container"
    [ngClass]="{ 'header__container--border': border }"
  >
    <div class="header__left">
      <img
        mfpLazyImage
        class="header__logo"
        lazySrc="assets/images/mapfre-logo.png"
      />
      <div class="header__title">
        <h2 class="title__primary">{{'LAYOUT.TITLE' | translate}}</h2>
        <p class="title__secondary">{{'LAYOUT.SUBTITLE' | translate}}</p>
      </div>
      <ng-container *ngIf="logged">
        <nav class="header__navigation">
          <ul class="navigation__list">
            <li
              class="navigation__item"
              [ngClass]="{'navigation__item--active': active === '0'}"
            >
              <span
                class="navigation__link"
                [ngClass]="{'navigation__link--active': active === '0'}"
                (click)="navigatePlanifications()"
              >{{'LAYOUT.TABS.0' | translate}}</span>
            </li>
            <li
              class="navigation__item"
              [ngClass]="{'navigation__item--active': active === '2'}"
            >
              <span
                class="navigation__link"
                [ngClass]="{'navigation__link--active': active === '2'}"
                (click)="navigateCommercialGuide()"
              >{{'LAYOUT.TABS.1' | translate}}</span>
            </li>
          </ul>
        </nav>
      </ng-container>
    </div>
    <div class="header__right">
      <ng-container *ngIf="logged">
        <div class="header__profile">
          <p class="profile__name">{{name}}</p>
          <div
            class="profile__avatar"
            (click)="openTooltip()"
            cdkOverlayOrigin
            #tooltip="cdkOverlayOrigin"
          >{{ name?.substr(0, 1) }}</div>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="tooltip"
            [cdkConnectedOverlayOpen]="tooltipActive"
            [cdkConnectedOverlayHasBackdrop]="true"
            cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
            (backdropClick)="openTooltip()"
          >
            <div class="profile__menu mfp-white-box">
              <a class="profile__menu-item" (click)="onLogout()" href="#">{{'LAYOUT.EXIT' | translate}}</a>
            </div>
          </ng-template>
        </div>
      </ng-container>
      <ng-container *ngIf="lifePlanId">
        <mfp-button
          class="header__summary"
          size="large"
          fill="clear"
          padding="none"
          icon="assets/icons/cart-dark.svg"
          (click)="navigateSummary()"
        ></mfp-button>
      </ng-container>
      <ng-container *ngIf="showMenu">
        <mfp-button
        class="header__menu"
        size="large"
        fill="clear"
        padding="none"
        icon="assets/icons/menu.svg"
        (click)="onMenuButtonClick()"
      ></mfp-button>
      </ng-container>
    </div>
  </div>
</header>
